export default __webpack_public_path__ + "static/media/square_trace.fc61e20c.png";